import { render, staticRenderFns } from "./FacePersonNameLabel.vue?vue&type=template&id=f1efc7e2"
import script from "./FacePersonNameLabel.vue?vue&type=script&lang=js"
export * from "./FacePersonNameLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports